import { supabase } from "@/integrations/supabase/client";

export const MEDICATION_REGIMEN_EVENT_TYPES = [
  ["inicio", "Início"],
  ["ajuste_dose", "Ajuste de dose"],
  ["mudanca_horario", "Mudança de horário"],
  ["manutencao", "Manutenção"],
  ["resposta", "Resposta / eficácia"],
  ["adverso", "Evento adverso"],
  ["pausa", "Pausa"],
  ["retomada", "Retomada"],
  ["suspensao", "Suspensão"],
  ["descontinuacao", "Descontinuação"],
  ["observacao", "Observação clínica"],
] as const;

export type MedicationRegimenEventInput = {
  owner_id: string;
  patient_id: string;
  patient_medication_id?: string | null;
  session_id?: string | null;
  event_at?: string | null;
  event_type: string;
  previous_dose?: number | null;
  new_dose?: number | null;
  dose_unit?: string | null;
  frequency?: string | null;
  usual_time?: string | null;
  status_before?: string | null;
  status_after?: string | null;
  reason?: string | null;
  target_update?: string | null;
  benefit_0_100?: number | null;
  adverse_0_100?: number | null;
  adherence_0_100?: number | null;
  clinician_assessment?: string | null;
  patient_report?: string | null;
  monitoring_plan?: string | null;
  next_step?: string | null;
  evidence_context?: string | null;
  source?: string | null;
  metadata?: Record<string, unknown>;
};

export async function recordMedicationRegimenEvent(input: MedicationRegimenEventInput) {
  const { data, error } = await (supabase as any)
    .from("patient_medication_regimen_events")
    .insert({
      ...input,
      event_at: input.event_at || new Date().toISOString(),
      metadata: input.metadata ?? {},
    })
    .select("*")
    .single();
  if (error) throw error;
  return data;
}

export async function listMedicationRegimenEvents(patientMedicationId: string) {
  const { data, error } = await (supabase as any)
    .from("patient_medication_regimen_events")
    .select("*")
    .eq("patient_medication_id", patientMedicationId)
    .is("deleted_at", null)
    .order("event_at", { ascending: false })
    .limit(120);
  if (error) throw error;
  return data ?? [];
}
